"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTriggerOrders = exports.getAllTriggersOrders = void 0;
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const trade_utils_lib_1 = require("trade_utils_lib");
const TriggersApi_1 = require("../../../apis/TriggersApi");
const usePullRefresh_1 = require("../../../hooks/usePullRefresh");
const interface_1 = require("../../../interface");
const Trade_1 = require("../../Trade");
const apis_1 = require("./apis");
const rx_1 = require("../CustomTPSLProvider/rx");
const TriggerOrdersPageLength = 10;
const TriggerFunction = {
    [interface_1.TriggerModeUI.NORMAL]: "NORMAL",
    [interface_1.TriggerModeUI.TP_SL]: "POSITION,ORDER,TRIGGER",
    [interface_1.TriggerModeUI.TRACK_BACK]: "POSITION",
};
const TriggerTypeMap = {
    [interface_1.TriggerModeUI.TP_SL]: [interface_1.TriggerType.GREATER_EQUAL, interface_1.TriggerType.LESS_EQUAL].join(","),
    [interface_1.TriggerModeUI.TRACK_BACK]: [interface_1.TriggerType.TRAILING_DOWN_REV, interface_1.TriggerType.TRAILING_UP_BACK].join(","),
};
/**校验数据是否合法 */
function validateData(data, triggerMode, withPositionOrOrder) {
    if (triggerMode === interface_1.TriggerModeUI.NORMAL) {
        return !withPositionOrOrder;
    }
    if (withPositionOrOrder) {
        if (triggerMode === interface_1.TriggerModeUI.TP_SL) {
            return Trade_1.TPSLUtils.isTPSLOrder(data);
        }
        if (triggerMode === interface_1.TriggerModeUI.TRACK_BACK) {
            return Trade_1.TPSLUtils.isTrackOrder(data);
        }
    }
    return false;
}
/**根据不同的数据类型生成对应的请求参数 */
function getTriggerFunctionType(triggerMode, isHistory = false) {
    const params = (() => {
        if (isHistory) {
            return {
                trigger_function: TriggerFunction[triggerMode],
            };
        }
        return triggerMode !== interface_1.TriggerModeUI.NORMAL
            ? {
                state: triggerMode === interface_1.TriggerModeUI.TP_SL ? "SUBMITTED" : "SUBMITTED,WAITING",
                trigger_function: "POSITION,ORDER,TRIGGER",
            }
            : { trigger_function: "NORMAL" };
    })();
    // 获取对应的trigger_type字段
    const trigger_type = TriggerTypeMap[triggerMode];
    if (trigger_type) {
        params["trigger_type"] = trigger_type;
    }
    return params;
}
const noop = () => (0, rxjs_1.of)([]);
/**
 * 返回查询条件单的api接口
 * @param isHistory 是否是历史订单
 * @param isTPSL 是否是止盈止损
 */
function getQueryApi(isHistory, isTPSL) {
    return isHistory ? TriggersApi_1.queryHistoryTriggers : isTPSL ? TriggersApi_1.queryAllTriggers : TriggersApi_1.queryActiveTriggers;
}
/**查询所有的止盈止损或者追踪出场 */
function getAllTriggersOrders(params) {
    return (0, TriggersApi_1.queryAllTriggers)(params);
}
exports.getAllTriggersOrders = getAllTriggersOrders;
/**
 * 当从wss获取到订单之后，通过该函数通知订单止盈止损或者仓位止盈止损进行数据更新
 * @param data 从后端推送过来的条件单
 * @param withOrderId 该条件单是否绑定了订单
 * @param withPositionId 该条件单是否绑定了止盈止损
 */
function notifyReceivedWSSData(data, withOrderId, withPositionId) {
    // 订单被撤销或者订单被关闭或者订单被拒绝（非open状态）
    if (data.status !== interface_1.TriggerOrderStatus.OPEN) {
        if (withOrderId) {
            // 触发删除订单关联的止盈止损
            (0, rx_1.dispatchOrderChangedEvent)({
                event: "remove",
                ids: [],
                orders: [data],
            });
        }
        if (withPositionId) {
            // 触发删除仓位关联的止盈止损
            (0, rx_1.dispatchPositionTpSlEvent)({
                event: "remove",
                ids: [],
                orders: [data],
            });
        }
        return;
    }
    // 新增订单或者订单更新
    if (withOrderId) {
        // 触发新增/更新订单关联的止盈止损
        (0, rx_1.dispatchOrderChangedEvent)({
            event: "update",
            ids: [data.trigger_order_id],
            orders: [data],
        });
    }
    if (withPositionId) {
        // 触发新增/更新仓位关联的止盈止损
        (0, rx_1.dispatchPositionTpSlEvent)({
            event: "update",
            ids: [data.trigger_position_id],
            orders: [data],
        });
    }
}
const NullArray = [];
/**
 * 通过该hooks获取条件单列表
 *
 * 当isHistory为false时，该hooks会在内部监听websocket推送，并实时更新条件单列表
 *
 * 目前支持了三种模式：
 * - TriggerModeUI.NORMAL 普通条件单
 * - TriggerModeUI.TP_SL 止盈止损
 * - TriggerModeUI.TRACK_BACK 追踪出场
 *
 * @param props @see {Props}
 * @param active
 * @returns
 */
function useTriggerOrders(props, active = true) {
    const { isHistory = false, symbol, symbolType = "PERP", orderStates, observerWSOrders, accountType, 
    // onOrderStateChanged,
    limit = TriggerOrdersPageLength, triggerMode = interface_1.TriggerModeUI.NORMAL, apiKey, } = props;
    // 缓存当前列表中的所有订单的id，以及id对应的index
    const dataMap = (0, react_1.useRef)(new Map());
    const symbolRef = (0, react_1.useRef)(symbol);
    symbolRef.current = symbol;
    // 发起接口请求时参数，包含一系列的筛选条件
    const filterParams = (0, react_1.useMemo)(() => (Object.assign({ symbol: symbol !== null && symbol !== void 0 ? symbol : "", state: (orderStates || []).join(","), symbol_type: symbolType }, getTriggerFunctionType(triggerMode, isHistory))), [symbol, orderStates, symbolType, triggerMode, isHistory]);
    // 当通过接口获取到新数据时，该函数会被usePullRefresh回调。
    // 函数中会更新dataMap，并且存储每个订单对应的数组下标
    const onProcessData = (0, react_1.useCallback)((source, indexOffset) => {
        const map = dataMap.current;
        if (indexOffset === 0) {
            map.clear();
        }
        source.forEach((item, index) => {
            map.set(item.trigger_id, { index: index + indexOffset, item });
        });
        return source;
    }, []);
    const _a = (0, usePullRefresh_1.usePullRefresh)({
        // 现货下不存在条件单，不应该发起请求
        query: symbolType === "SPOT" ? noop : getQueryApi(isHistory, triggerMode !== interface_1.TriggerModeUI.NORMAL),
        getLoadMoreParams: (source) => {
            if (!source.length) {
                return undefined;
            }
            return { page_cursor: source[source.length - 1].next_page_cursor };
        },
        // 历史订单不需要缓存数据
        onProcessData: isHistory ? undefined : onProcessData,
        filterParams,
        pageLimit: limit,
        accountType,
        active: active && !!apiKey,
    }), { setListData } = _a, others = __rest(_a, ["setListData"]);
    (0, react_1.useEffect)(() => {
        if (!apiKey) {
            setListData([]);
        }
    }, [apiKey, setListData]);
    const updateRef = (0, react_1.useRef)(setListData);
    const { listData, refresh } = others;
    (0, react_1.useEffect)(() => {
        if (isHistory || !observerWSOrders) {
            return;
        }
        // 非历史模式下，需要监听wss的推送数据，并更新数据到列表中
        const sub = observerWSOrders().subscribe({
            next: (data) => {
                const { trigger_id, status, created_time, trigger_position_id = "", trigger_order_id = "", trigger_trigger_id = "" } = data;
                // 注意：仓位id以及订单的id不能只是简单的判空，必须确保长度大于1
                const withPositionId = (trigger_position_id || "").length > 1;
                const withOrderId = (trigger_order_id || "").length > 1;
                const withTriggerOrderId = (trigger_trigger_id || "").length > 1;
                const withPositionOrOrder = withPositionId || withOrderId;
                // 止盈止损或者追踪出场模式下，过滤掉普通条件单
                // 否则就过滤掉止盈止损单
                const isValidData = validateData(data, triggerMode, withPositionOrOrder);
                if (!isValidData) {
                    return;
                }
                // 存在选中的币对，推送的数据为非选中币对的订单，则不处理
                if (symbolRef.current && data.symbol !== symbolRef.current) {
                    return;
                }
                // 获取当前已经缓存的订单map
                const map = dataMap.current;
                // 获取更新列表的function
                const updateListData = updateRef.current;
                /**通知订单/仓位关联的数据已经更新 */
                withPositionOrOrder && notifyReceivedWSSData(data, withOrderId, withPositionId);
                // 如果为条件单止盈止损订单
                if (withTriggerOrderId) {
                    const item = dataMap.current.get(trigger_trigger_id);
                    // 如果能获取到父条件单，则可以将此止盈止损单补充到父条件单，所以这里不用判断triggerMode类型
                    if (item) {
                        const triggerOrder = item.item;
                        const index = item.index;
                        if (triggerOrder) {
                            triggerOrder.triggers = triggerOrder.triggers || [];
                            if (status === interface_1.TriggerOrderStatus.OPEN) {
                                triggerOrder.triggers = [...triggerOrder.triggers, data];
                            }
                            else {
                                triggerOrder.triggers = triggerOrder.triggers.filter((order) => order.trigger_id !== trigger_id);
                            }
                            map.set(triggerOrder.trigger_id, { index, item: triggerOrder });
                            updateListData((origin) => {
                                const newList = origin.slice();
                                newList.splice(index, 1, Object.assign({}, triggerOrder));
                                return newList;
                            });
                        }
                        return;
                    }
                }
                if (map.has(trigger_id)) {
                    // 已经存在该订单
                    const item = map.get(trigger_id);
                    // 该订单不处于open状态，则需要移除
                    if (status !== interface_1.TriggerOrderStatus.OPEN) {
                        // 移除条件单
                        updateListData((origin) => {
                            const removeIndex = item.index;
                            // 由于需要移除当前订单，则所有在当前订单之后的订单的在dataMap中的索引都会减1
                            // 获取当前订单的索引，从下一个订单开始往后遍历，获取到对应的订单id，并且更新dataMap总每个id对应的index-1
                            for (let i = removeIndex + 1; i < origin.length; i++) {
                                const { trigger_id } = origin[i];
                                const mapData = map.get(trigger_id);
                                if (mapData) {
                                    mapData.index--;
                                }
                            }
                            // 从dataMap中删除该订单
                            map.delete(trigger_id);
                            // 从列表中删除该订单
                            return (0, usePullRefresh_1.removeItem)(origin, removeIndex);
                        });
                        // 正常关闭
                        if (status === interface_1.TriggerOrderStatus.CANCELED) {
                            // TODO: 被撤销
                        }
                        else if (status === interface_1.TriggerOrderStatus.CLOSED) {
                            // TODO: 成功挂单
                        }
                    }
                    else {
                        // 追踪出场跟止盈止损需要动态更新
                        if (item) {
                            const index = item.index;
                            // 更新订单
                            updateListData((origin) => {
                                const newList = origin.slice(0);
                                newList.splice(index, 1, data);
                                return newList;
                            });
                        }
                    }
                    return;
                }
                // 缓存中不存在该订单，并且订单状态为非open，则直接忽略该订单
                // 该场景可能是这个订单在更加后面的分页中，目前的列表中还没获取到这个订单，但是该订单被成交了的情况
                if (status !== interface_1.TriggerOrderStatus.OPEN) {
                    return;
                }
                // 不存在该订单，或者全新的订单
                updateListData((origin) => (0, usePullRefresh_1.insetItemIfNeed)(origin, (item) => {
                    // 检测是否需要将该订单插入到列表中，参数传入的item为列表中的第一条数据（item代表最新的一个条件单）
                    // 1. !item代表当前列表为空，则可以直接插入数据
                    // 2. 当item存在时，需要判断新增订单的创建时间是否大于item.created_time
                    // 3. 由于前端获取到后端推送的数据的时间点并不能完全确保跟创建订单的顺序保持一致，所以额外加了一个buffer，只要两条数据之间的时间差小于5s，则认为可以新增到列表中
                    let willInsert = !item ||
                        new trade_utils_lib_1.SafeDecimal(created_time).gt(new trade_utils_lib_1.SafeDecimal(item.created_time)) ||
                        // 新增一个时间戳buffer，避免因为网络波动导致后端推送订单的时间戳晚于当前最新一条订单的时间戳而无法被插入的到列表的问题
                        new trade_utils_lib_1.SafeDecimal(item.created_time).sub(new trade_utils_lib_1.SafeDecimal(created_time)).abs().lt(5000);
                    if (willInsert) {
                        // 基于不同的条件单模式再次判断是否可以新增
                        switch (triggerMode) {
                            case interface_1.TriggerModeUI.TP_SL:
                                // 止盈止损模式下，只插入状态为submit的止盈止损单
                                willInsert = data.origin_order_state === interface_1.TriggerOrderState.SUBMITTED && Trade_1.TPSLUtils.isTPSLOrder(data);
                                break;
                            case interface_1.TriggerModeUI.TRACK_BACK:
                                // 追踪出场模式下，允许插入状态为SUBMITTED，WAITING的追踪出场单
                                willInsert =
                                    [interface_1.TriggerOrderState.SUBMITTED, interface_1.TriggerOrderState.WAITING].includes(data.origin_order_state) &&
                                        Trade_1.TPSLUtils.isTrackOrder(data);
                                break;
                            default:
                                // 普通模式条件单模式，则直接使用willInsert的值
                                break;
                        }
                    }
                    if (willInsert) {
                        // 由于在0号位插入数据，因此需要将当前dataMap中所有数据的index+1
                        for (const [, item] of map) {
                            item.index++;
                        }
                        // 将新数据的index更新到map中
                        map.set(trigger_id, { index: 0, item: data });
                    }
                    // 返回是否需要新增数据
                    return willInsert;
                }, data));
            },
            error: (err) => {
                console.log(err);
            },
        });
        return () => sub.unsubscribe();
    }, [active, isHistory, observerWSOrders, triggerMode]);
    /**批量撤销条件单 */
    const batchCancelTriggers = (0, react_1.useCallback)(() => {
        if (!listData.length) {
            return Promise.reject("no triggers to cancel");
        }
        const needCancel = listData.slice(0, 10).map((e) => {
            return { triggerId: e.trigger_id, symbol: e.symbol, accountType: accountType };
        });
        return (0, apis_1.batchCancelTriggerOrder)(needCancel).then((res) => {
            refresh();
            return res;
        });
    }, [accountType, listData, refresh]);
    return Object.assign(Object.assign({}, others), { listData: !!apiKey ? others.listData : NullArray, batchCancelTriggers });
}
exports.useTriggerOrders = useTriggerOrders;
